var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 248 248",
    style: {
      enableBackground: "new 0 0 248 248"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#091726;}\n\t.st2{opacity:0.72;fill:url(#SVGID_2_);enable-background:new    ;}\n\t.st3{opacity:0.58;fill:url(#SVGID_3_);enable-background:new    ;}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:#31CDF3;}\n\t.st6{fill:#6CE1F5;}\n\t.st7{opacity:0.4;fill:url(#SVGID_5_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.609,
    y1: 66.68951,
    x2: 203.91156,
    y2: 66.68951,
    gradientTransform: "matrix(1 0 0 -1 0 248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF33B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0401,
    style: {
      stopColor: "#FEE72E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#FED51B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1964,
    style: {
      stopColor: "#FDCA10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FDC70C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#F3903F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#ED683C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E93E3A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.901,163.53799c0.01199-0.202,0.01601-0.40401,0-0.604V154.174H44.609v9.479 c0.008,1.814,1.123,3.545,3.415,4.839l67.315,38.02c5.075,2.866,13.94,2.507,19.8-0.80299l63.937-36.112 c2.964-1.674,4.586-3.782,4.815-5.827h0.00999V163.53799z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.965,198.21201l-67.444-38.939c-5.085-2.936-4.447-8.064,1.424-11.453l64.06-36.985 c5.871-3.39,14.753-3.758,19.838-0.822l67.444,38.939c5.08501,2.936,4.44701,8.064-1.424,11.453l-64.06,36.985 C128.93201,200.77901,120.05,201.147,114.965,198.21201z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.08817,
    y1: 93.88786,
    x2: 203.71982,
    y2: 93.88786,
    gradientTransform: "matrix(1 0 0 -1 0 248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF33B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0401,
    style: {
      stopColor: "#FEE72E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#FED51B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1964,
    style: {
      stopColor: "#FDCA10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FDC70C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#F3903F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#ED683C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E93E3A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.965,198.21201l-67.444-38.939c-5.085-2.936-4.447-8.064,1.424-11.453l64.06-36.985 c5.871-3.39,14.753-3.758,19.838-0.822l67.444,38.939c5.08501,2.936,4.44701,8.064-1.424,11.453l-64.06,36.985 C128.93201,200.77901,120.05,201.147,114.965,198.21201z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.609,
    y1: 88.76051,
    x2: 203.91156,
    y2: 88.76051,
    gradientTransform: "matrix(1 0 0 -1 0 248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF33B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0401,
    style: {
      stopColor: "#FEE72E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#FED51B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1964,
    style: {
      stopColor: "#FDCA10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FDC70C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#F3903F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#ED683C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E93E3A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M203.901,141.467c0.01199-0.202,0.01601-0.40401,0-0.604V132.103H44.609v9.479 c0.008,1.814,1.123,3.545,3.415,4.839l67.315,38.02c5.075,2.866,13.94,2.507,19.8-0.80299l63.937-36.112 c2.964-1.674,4.586-3.782,4.815-5.827h0.00999V141.467z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.08817,
    y1: 115.36368,
    x2: 203.71982,
    y2: 115.36368,
    gradientTransform: "matrix(1 0 0 -1 0 248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF33B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0401,
    style: {
      stopColor: "#FEE72E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#FED51B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1964,
    style: {
      stopColor: "#FDCA10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FDC70C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#F3903F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#ED683C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E93E3A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.965,176.73599l-67.444-38.939c-5.085-2.936-4.447-8.064,1.424-11.453l64.06-36.985 c5.871-3.39,14.753-3.758,19.838-0.822l67.444,38.939c5.08501,2.936,4.44701,8.064-1.424,11.453l-64.06,36.985 C128.93201,179.30299,120.05,179.672,114.965,176.73599z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.23599,136.526l-1.724,0.996l-37.871,21.86301c-3.631,2.095-9.119,2.321-12.259,0.506l-39.083-22.563 l-2.607-1.50301c-3.14-1.815-2.747-4.98199,0.883-7.078l39.595-22.86c3.625-2.095,9.119-2.322,12.259-0.512l41.685,24.072 C174.259,131.26401,173.86099,134.431,170.23599,136.526z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M168.51199,137.522l-37.871,21.86301c-3.631,2.095-9.119,2.321-12.259,0.506l-39.083-22.563l37.87099-21.863 c3.625-2.095,9.119-2.322,12.259-0.506L168.51199,137.522z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.3405,
    y1: 91.5226,
    x2: 123.3405,
    y2: 207.05231,
    gradientTransform: "matrix(1 0 0 -1 0 248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CE1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6CE1F5",
      stopOpacity: 0
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M184.80701,39.553l-11.56799,92.90699c0.022,1.39999-0.99699,2.88699-3,4.045l-1.72301,0.99699 l-37.871,21.86301c-3.631,2.095-9.119,2.32201-12.259,0.506L79.3,137.30701l-2.607-1.50301c-1.282-0.743-1.982-1.713-2.101-2.742 h-0.006L61.874,40.634"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.e16588f192ec05f09456f93f30677c78.svg";
export { ForwardRef as ReactComponent };